// client/src/components/admin/PendingNameChanges.js — Maxula
// Panneau admin : demandes de changement de nom marchand (approuver / refuser).
import React, { useEffect, useState, useCallback } from 'react';
import { FiCheck, FiX, FiTag } from 'react-icons/fi';
import { toast } from 'react-toastify';
import API from '../../services/api';

export default function PendingNameChanges() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busyId, setBusyId] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await API.get('/merchants/name-changes/pending');
      setRows((data && data.data) || []);
    } catch (e) { setRows([]); } finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const act = async (id, action) => {
    setBusyId(id);
    try {
      await API.put(`/merchants/${id}/name/${action}`);
      toast.success(action === 'approve' ? 'Nom approuvé' : 'Demande refusée');
      setRows((prev) => prev.filter((r) => String(r.id) !== String(id)));
    } catch (e) {
      toast.error('Action impossible');
    } finally { setBusyId(null); }
  };

  if (loading || !rows.length) return null;

  return (
    <div style={{ border: '1px solid #f5c6dd', background: '#fdf2f8', borderRadius: 10, padding: 16, marginBottom: 20 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12, fontWeight: 700, color: '#9d174d' }}>
        <FiTag /> Demandes de changement de nom ({rows.length})
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {rows.map((m) => (
          <div key={m.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap', background: '#fff', border: '1px solid #fbcfe8', borderRadius: 8, padding: '10px 14px' }}>
            <div style={{ fontSize: 14 }}>
              <span style={{ color: '#6b7280', textDecoration: 'line-through' }}>{m.businessName}</span>
              <span style={{ margin: '0 8px', color: '#9ca3af' }}>&rarr;</span>
              <span style={{ fontWeight: 700, color: '#E11D79' }}>{m.pendingName}</span>
              {m.legalName ? <span style={{ display: 'block', fontSize: 12, color: '#9ca3af', marginTop: 2 }}>Nom légal : {m.legalName}</span> : null}
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button type="button" disabled={busyId === m.id} onClick={() => act(m.id, 'approve')}
                style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 14px', borderRadius: 8, border: 'none', background: '#16a34a', color: '#fff', fontWeight: 700, fontSize: 13, cursor: 'pointer', opacity: busyId === m.id ? 0.6 : 1 }}>
                <FiCheck size={15} /> Approuver
              </button>
              <button type="button" disabled={busyId === m.id} onClick={() => act(m.id, 'reject')}
                style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 14px', borderRadius: 8, border: '1px solid #e5e7eb', background: '#fff', color: '#374151', fontWeight: 700, fontSize: 13, cursor: 'pointer', opacity: busyId === m.id ? 0.6 : 1 }}>
                <FiX size={15} /> Refuser
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
